let id_gen = 0;

/**
 * <b>잡다한걸 처리하는 util에서도 잡다한걸 처리하는 etc입니다.</b>
 * <pre>
 * 여러가지 부수적인 처리를 합니다. 어찌보면 쓸일 없을 수도 있습니다.
 * </pre>
 */
class Etc {

    /**
     * <b>색을 랜덤으로 만듭니다.</b>
     * @return {String} color - 색을 리턴합니다.
     */
    makeRandomColor() {
        let color = '';
        let unit;
        for (let i = 0; i < 3; i++) {
            unit = Math.floor(Math.random() * 255).toString(16);
            unit = unit.length === 1 ? '0' + unit : unit;
            color += unit;
        }
        color = '#' + color;
        return color;
    }

    /**
     * <b>전역 id를 리턴합니다. generate하는 id는 g가 붙습니다.</b>
     * @return {String} id - g+숫자 형식으로 리턴합니다.
     */
    makeGlobalId() {
        return 'g' + id_gen++;
    }

    /**
     * <b>해당 문자열이 소문자인지 확인합니다.<b/>
     * <pre>해당 문자열이 소문자인지 확인합니다.</pre>
     * @param {String} str - 확인할 문자열을 넣습니다.
     * @return {Boolean} is_lower_case - 소문자이면 true를 아니면 false를 리턴합니다. 
     */
    isLowerCase(str) {
        if (typeof str === 'number') {
            return false;
        }
        for (let atom of str) {
            if (0 <= Number(atom) && Number(atom) <= 9) {
                return false;
            }
        }
        return (typeof str === 'string') ? (str === str.toLowerCase()) : false;
    }

    /**
     * <b>해당 문자열이 대문자인지 확인합니다.</b>
     * <pre>해당 문자열이 대문자인지 확인합니다.</pre>
     * @param {String} str - 확인할 문자열을 넣습니다.
     * @return {Boolean} is_upper_case - 대문자이면 true를 아니면 false를 리턴합니다. 
     */
    isUpperCase(str) {
        if (typeof str === 'number') {
            return false;
        }
        for (let atom of str) {
            if (0 <= Number(atom) && Number(atom) <= 9) {
                return false;
            }
        }
        return (typeof str === 'string') ? (str === str.toUpperCase()) : false;
    }

    /**
     * <b>camel 케이싱으로 된 문자를 분해하여 배열로 반환합니다.</b>
     * @param {String} str - 분해할 문자열을 입력합니다.
     * @param {Boolean} is_lower - 출력할 값을 소문자로 할건지 정합니다. false로 하면 대문자로 전환됩니다.
     * @return {Array} arr - 배열을 반환합니다.
     */
    camelToArray(str, is_lower = true) {
        let cnt = 0;
        let arr = [];
        let tmp = '';
        let is_init = false;
        for (let atom of str) {
            if (this.isUpperCase(atom) && is_init) {
                arr[cnt++] = is_lower ? tmp.toLowerCase() : tmp.toUpperCase();
                tmp = atom;
            } else {
                tmp += atom;
                is_init = true;
            }
        }
        if (tmp !== '') {
            arr[cnt++] = is_lower ? tmp.toLowerCase() : tmp.toUpperCase();
        }
        return arr;
    }

    /**
     * <b>pascal 케이싱으로 된 문자를 분해하여 배열로 반환합니다.</b>
     * @param {String} str - 분해할 문자열을 입력합니다.
     * @param {Boolean} is_lower - 출력할 값을 소문자로 할건지 정합니다. false로 하면 대문자로 전환됩니다.
     * @return {Array} arr - 배열을 반환합니다.
     */
    pascalToArray(str, is_lower = true) {
        return this.camelToArray(str, is_lower);
    }

    /**
     * <b>snake 케이싱으로 된 문자를 분해하여 배열로 반환합니다.</b>
     * @param {String} str - 분해할 문자열을 입력합니다.
     * @param {Boolean} is_lower - 출력할 값을 소문자로 할건지 정합니다. false로 하면 대문자로 전환됩니다.
     * @return {Array} arr - 배열을 반환합니다.
     */
    snakeToArray(str, is_lower = true) {
        let cnt = 0;
        let arr = [];
        let tmp = '';
        for (let atom of str) {
            if (atom === '_' && tmp !== '') {
                arr[cnt++] = is_lower ? tmp.toLowerCase() : tmp.toUpperCase();
                tmp = '';
            } else if (atom === '_' && tmp === '') {
                continue;
            } else {
                tmp += atom;
            }
        }
        if (tmp !== '') {
            arr[cnt++] = is_lower ? tmp.toLowerCase() : tmp.toUpperCase();
        }
        return arr;
    }

    /**
     * <b>macro 케이싱으로 된 문자를 분해하여 배열로 반환합니다.</b>
     * @param {String} str - 분해할 문자열을 입력합니다.
     * @param {Boolean} is_lower - 출력할 값을 소문자로 할건지 정합니다. false로 하면 대문자로 전환됩니다.
     * @return {Array} arr - 배열을 반환합니다.
     */
    macroToArray(str, is_lower = true) {
        this.snakeToArray(str, is_lower);
    }

    /**
     * <b>period 케이싱으로 된 문자를 분해하여 배열로 반환합니다.</b>
     * @param {String} str - 분해할 문자열을 입력합니다.
     * @param {Boolean} is_lower - 출력할 값을 소문자로 할건지 정합니다. false로 하면 대문자로 전환됩니다.
     * @return {Array} arr - 배열을 반환합니다.
     */
    periodToArray(str, is_lower = true) {
        let cnt = 0;
        let arr = [];
        let tmp = '';
        for (let atom of str) {
            if (atom === '.' && tmp !== '') {
                arr[cnt++] = is_lower ? tmp.toLowerCase() : tmp.toUpperCase();
                tmp = '';
            } else if (atom === '.' && tmp === '') {
                continue;
            } else {
                tmp += atom;
            }
        }
        if (tmp !== '') {
            arr[cnt++] = is_lower ? tmp.toLowerCase() : tmp.toUpperCase();
        }
        return arr;
    }

    /**
     * <b>해당 문자가(반드시 한 글자짜리여야합니다.) 문자열인지 확인합니다. 만약 두글자 이상이면 false를 리턴하니 주의하세요.</b>
     * @param {String} str - 검사하고 싶은 문자를 넣습니다.
     * @return {Boolean} is_alpha - 알파벳인지 아닌지를 반환합니다.
     */
    isAlpha(str) {
        return (('a' <= str && str <= 'z') || ('A' <= str && str <= 'Z')) && str.length === 1;
    }

    /**
     * <b>해당 문자가 혹은 숫자가 숫자인지 확인합니다. 아닐시 flase를 리턴합니다. 단 NaN는 false를 반환합니다.</b>
     * @param {Any} num - 검사하고 싶은 문자열 혹은 숫자를 넣습니다.
     * @return {Boolean} is_number - 숫자인지 아닌지를 반환합니다.
     */
    isNumber(num) {
        if (typeof num === 'number' && isNaN(num)) {
            return false;
        }
        if(num === ' '){
            return false;
        }
        if (typeof num === 'number') {
            return true;
        } else if (typeof num === 'string' && num == Number(num) && num !== '') {
            return true;
        } else {
            return false;
        }
    }

    /**
     * <b>해당 문자열이 .으로 끊기는 문자열인지 확인합니다.</b>
     * @param {String} str - 확인하고 싶은 문자열을 넣습니다.
     * @return {Boolean} is_period_case - 해당 캐이스가 맞는지 확인합니다.
     */
    isPeriodCase(str) {
        if (str[0] === '.' || str[str.length - 1] === '.' || str.length === 0) {
            return false;
        }
        for (let atom in str) {
            if (!(this.isAlpha(str[atom]) || this.isNumber(str[atom]) || str[atom] === '.')) {
                return false;
            }
        }
        return true;
    }

    /**
     * <b>해당 문자열이 _으로 끊기는 문자열인지 확인합니다.</b>
     * @param {String} str - 확인하고 싶은 문자열을 넣습니다.
     * @return {Boolean} is_snake_case - 해당 캐이스가 맞는지 확인합니다.
     */
    isSnakeCase(str){
        if (str[0] === '_' || str[str.length - 1] === '_' || str.length === 0) {
            return false;
        }
        for (let atom in str) {
            if (!(this.isAlpha(str[atom]) || this.isNumber(str[atom]) || str[atom] === '_')) {
                return false;
            }
        }
        return true;
    }

    /**
     * <b>해당 문자열이 카멜 케이싱인지 확인합니다..</b>
     * @param {String} str - 확인하고 싶은 문자열을 넣습니다.
     * @return {Boolean} is_camel_case - 해당 캐이스가 맞는지 확인합니다.
     */
    isCamelCase(str){
        if(!(this.isAlpha(str[0]) && this.isLowerCase(str[0]))){
            return false;
        }
        for (let atom in str) {
            if (!(this.isAlpha(str[atom]) || this.isNumber(str[atom]))) {
                return false;
            }
        }
        return true;
    }

    /**
     * <b>해당 문자열이 파스칼 케이싱인지 확인합니다..</b>
     * @param {String} str - 확인하고 싶은 문자열을 넣습니다.
     * @return {Boolean} is_pascal_case - 해당 캐이스가 맞는지 확인합니다.
     */
    isPascalCase(str){
        if(!this.isAlpha(str[0]) && !this.isUpperCase(str[0])){
            return false;
        }
        for (let atom in str) {
            if (!(this.isAlpha(str[atom]) || this.isNumber(str[atom]))) {
                return false;
            }
        }
        return true;
    }

    /**
     * <b>숫자를 ',' 가 표현된 문자열로 변환합니다..</b>
     * @param {Number} num - 변환하고싶은 숫자를 넣습니다.
     * @return {String} make_comma_number - 문자열을 반환합니다.
     */
    makeCommaNumber(num) {
        num = String(num);
        return num.replace(/(\d)(?=(?:\d{3})+(?!\d))/g, '$1,');
    }
}

export default new Etc();